import { chartColorsMixin } from "@/modules/global/mixins/chartColorsMixin.js";
import { filteredUsersMixin } from "@/modules/global/mixins/filteredUsersMixin.js";
import { mapState } from "vuex";

export default {
  data() {
    return {
      baseStackedChartOptions: {
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: "right"
        },
        responsive: true
      },
      cpChart: {
        data: null,
        extraOptions: null
      },
      impChart: {
        data: null,
        extraOptions: null
      }
    };
  },
  mixins: [chartColorsMixin, filteredUsersMixin],
  computed: {
    ...mapState({
      threadId: state => state.globalStore.activeFilterParams.threadId,
      currentSubject: state =>
        state.globalStore.activeFilterParams.currentSubject
    }),
    sortedCatchupData() {
      if (this.completedActiveAssessment.length > 0) {
        return this.completedActiveAssessment.sort(
          this.sortByNumberOfMasteredConcepts
        );
      }
      return [];
    },
    sortedImprovementData() {
      if (this.fetchedImprovements) {
        return this.completedActiveAssessment.sort(this.sortByImprovement);
      }
    },
    masteredConceptsPerUser() {
      let output = {
        mastered: [],
        done: [],
        togo: [],
        labels: [],
        chartType: 3
      };
      if (this.sortedCatchupData.length > 0) {
        this.sortedCatchupData.forEach(user => {
          const catchupState = user.catchupStates.find(
            catchupState =>
              catchupState.assessmentId === user.assessmentStates[0]._id
          );
          if (catchupState.threads[this.threadId].conceptMastery) {
            let mastered = catchupState.threads[
              this.threadId
            ].conceptMastery.filter(concept => concept === 3).length;
            let done = this.numberOfConceptsGoneThrough(catchupState);
            let unmastered =
              catchupState.threads[this.threadId].conceptMastery.length -
              mastered -
              done;
            // let unmastered = totalUnmastered - done;
            output.mastered.push(mastered);
            output.done.push(done);
            output.togo.push(unmastered);
            output.labels.push(`${user.firstName} ${user.lastName}`);
          }
        });
      }
      return output;
    },
    improvementsPerUser() {
      let output = {
        initial: [],
        reassess: [],
        labels: [],
        chartType: 4
      };
      if (this.sortedImprovementData && this.sortedImprovementData.length > 0) {
        let actualThreadId = this.threadId + 1;
        this.sortedImprovementData.forEach(user => {
          if (
            user.improvement &&
            user.improvement[this.currentSubject][actualThreadId]
          ) {
            let initial = user.improvement[this.currentSubject][
              actualThreadId
            ].find(entry => entry.reassessment === false).relGradeMastered;

            let reassessments = user.improvement[this.currentSubject][
              actualThreadId
            ].filter(entry => {
              if (entry.reassessment === true) {
                return entry;
              }
            });

            let reassess = reassessments.map(entry =>
              entry.relGradeMastered > 0 ? entry.relGradeMastered : 0
            );

            output.initial.push(initial);
            output.reassess.push(reassess);
            output.labels.push(`${user.firstName} ${user.lastName}`);
          }
        });
      }
      return output;
    }
  },
  mounted() {
    this.stackedBarGraph(this.masteredConceptsPerUser);
    this.stackedImprovementBarGraph(this.improvementsPerUser);
  },
  methods: {
    sortByNumberOfMasteredConcepts(a, b) {
      let user1;
      let user2;
      if (
        a.catchupStates[0].threads[this.threadId].conceptMastery !== null &&
        a.catchupStates[0].threads[this.threadId].conceptMastery !== undefined
      ) {
        user1 = a.catchupStates[0].threads[this.threadId].conceptMastery.filter(
          concept => concept === 3
        );
      }
      if (
        b.catchupStates[0].threads[this.threadId].conceptMastery !== null &&
        b.catchupStates[0].threads[this.threadId].conceptMastery !== undefined
      ) {
        user2 = b.catchupStates[0].threads[this.threadId].conceptMastery.filter(
          concept => concept === 3
        );
      }
      if (user1 > user2) {
        return 1;
      } else if (user1 < user2) {
        return -1;
      } else {
        return 0;
      }
    },
    sortByImprovement(a, b) {
      const user1 = a.improvement
        ? a.improvement[this.currentSubject][this.threadId + 1]
          ? a.improvement[this.currentSubject][this.threadId + 1][
            a.improvement[this.currentSubject][this.threadId + 1].length - 1
          ].gradeMastered
          : null
        : null;
      const user2 = b.improvement
        ? b.improvement[this.currentSubject][this.threadId + 1]
          ? b.improvement[this.currentSubject][this.threadId + 1][
            b.improvement[this.currentSubject][this.threadId + 1].length - 1
          ].gradeMastered
          : null
        : null;

      if (user1 > user2) {
        return 1;
      } else if (user1 < user2) {
        return -1;
      } else {
        return 0;
      }
    },
    numberOfConceptsGoneThrough(catchupState) {
      //filter all the concepts not mastered
      let i = [];
      catchupState.threads[this.threadId].conceptMastery.forEach(
        (concept, index) => {
          if (concept !== 3) {
            i.push(index);
          }
        }
      );
      //find index of unmastered concept
      let currentConcept =
        catchupState.threads[this.threadId].stage.concept;

      if (currentConcept === 0) {
        return 0;
      } else {
        let isIndexThere = i.findIndex(index => index === currentConcept - 1);
        if (isIndexThere === -1) {
          return i.length;
        } else {
          return isIndexThere;
        }
      }
    },
    stackedBarGraph(params) {
      let data = {
        labels: params.labels,
        datasets: [
          {
            label: "Mastered Concepts",
            data: params.mastered,
            backgroundColor: () => {
              return this.green;
            }
          },
          {
            label: "Concepts already covered",
            data: params.done,
            backgroundColor: () => {
              return this.yellow;
            }
          },
          {
            label: "Concepts left to do",
            data: params.togo,
            backgroundColor: () => {
              return this.red;
            }
          }
        ]
      };
      let extraOptions = {
        ...this.baseStackedChartOptions,
        scales: {
          yAxes: [
            {
              stacked: true,
              gridLines: {
                drawBorder: true,
                color: "rgba(29,140,248,0.0)"
              },
              scaleLabel: {
                display: true,
                labelString: "Concept Progress",
                fontStyle: "bold",
                fontSize: "16"
              },
              ticks: {
                display: true,
                beginAtZero: true,
                fontColor: "#9a9a9a",
                callback: function (value) {
                  if (Number.isInteger(value)) {
                    return `${value}`;
                  }
                }
              }
            }
          ],

          xAxes: [
            {
              stacked: true,
              gridLines: {
                drawBorder: true,
                color: "rgba(225,78,202,0.1)"
              },
              scaleLabel: {
                display: true,
                labelString: "Users",
                fontStyle: "bold",
                fontSize: "16"
              },
              ticks: {
                display: false,
                fontColor: "#9a9a9a"
              }
            }
          ]
        },
        hover: {
          onHover: function (e) {
            var point = this.getElementAtEvent(e);
            if (point.length) e.target.style.cursor = "pointer";
            else e.target.style.cursor = "default";
          }
        },
        onClick: (event, item) => {
          if (item.length > 0) {
            let index = item[0]._index;
            this.catchupChartClicked(index, params.chartType);
            this.updateLearnerModal(true);
          }
        }
      };
      this.cpChart.data = { ...data };
      this.cpChart.extraOptions = { ...extraOptions };
    },
    catchupChartClicked(index, chartType) {
      this.updateActiveLearner(this.sortedCatchupData[index]);
      this.updateActiveLearnerButton(chartType - 2);
    },
    stackedImprovementBarGraph(params) {
      let data = {
        labels: params.labels,
        datasets: [
          {
            label: "Initial Results",
            data: params.initial,
            backgroundColor: () => {
              return this.yellow;
            },
            minBarLength: 4
          }
        ]
      };
      params.reassess.forEach((entry, entryIndex) => {
        for (let index in entry) {
          let actualIndex = parseInt(index) + 1;
          if (!data.datasets[actualIndex]) {
            data.datasets.push({
              label: `Reassessment ${actualIndex} gain`,
              data: [],
              backgroundColor: () => {
                return this[`green${actualIndex}`];
              }
            });
          }
          data.datasets[actualIndex].data[entryIndex] = entry[index]
            ? entry[index]
            : 0;
        }
      });

      let extraOptions = {
        ...this.baseStackedChartOptions,
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              stacked: true,
              gridLines: {
                drawBorder: true,
                color: "rgba(29,140,248,0.0)"
              },
              scaleLabel: {
                display: true,
                labelString: "Grade Mastered",
                fontStyle: "bold",
                fontSize: "16"
              },
              ticks: {
                display: true,
                beginAtZero: true,
                fontColor: "#9a9a9a",
                callback: function (value) {
                  if (Number.isInteger(value)) {
                    return `${value}`;
                  }
                }
              }
            }
          ],

          xAxes: [
            {
              stacked: true,
              gridLines: {
                drawBorder: true,
                color: "rgba(225,78,202,0.1)"
              },
              scaleLabel: {
                display: true,
                labelString: "Users",
                fontStyle: "bold",
                fontSize: "16"
              },
              ticks: {
                display: false,
                fontColor: "#9a9a9a"
              }
            }
          ]
        },
        hover: {
          onHover: function (e) {
            var point = this.getElementAtEvent(e);
            if (point.length) e.target.style.cursor = "pointer";
            else e.target.style.cursor = "default";
          }
        },
        onClick: (event, item) => {
          if (item.length > 0) {
            let index = item[0]._index;
            this.catchupChartClicked(index, params.chartType);
            this.updateLearnerModal(true);
          }
        }
        // tooltips: {
        //   callbacks: {
        //     title: (tooltipItem, data) => {
        //       return data["labels"][tooltipItem[0]["index"]];
        //     },
        //     label: (tooltipItem, data) => {
        //       let percentSign = "";
        //       return (
        //         "Mastered at grade: " +
        //         Math.floor(data["datasets"][0]["data"][tooltipItem.index]) +
        //         percentSign
        //       );
        //     }
        //   }
        // }
      };
      this.impChart.data = { ...data };
      this.impChart.extraOptions = { ...extraOptions };
    }
  },
  watch: {
    sortedCatchupData: {
      handler: function () {
        this.stackedBarGraph(this.masteredConceptsPerUser);
      }
    },
    sortedImprovementData: {
      handler: function () {
        this.stackedImprovementBarGraph(this.improvementsPerUser);
      }
    },
    fetchedImprovements: {
      handler: function (value) {
        if (value) {
          this.stackedImprovementBarGraph(this.improvementsPerUser);
        }
      }
    }
  }
};
